import React, { useRef } from "react";
import cx from "classnames";
import { Icon } from "@showitinc/showit-wc";
import OverlayTrigger from "./base/OverlayTrigger";
import Popover from "./base/Popover";
import uiPrefix from "../utils/UiPrefixUtils";

function ContextMenu({
  placement,
  baseClassName = "si-c-contextmenu",
  children,
  iconClasses = "glyphicon glyphicon-more",
  iconComponent, // optional icon from Showit UI library
  hiddenToStart = true,
  label,
  orientation,
  closeOnClick = true,
  selectOnTrigger = false,
  triggerPrefixClass = "",
}) {
  const buttonRef = useRef(null);

  const style = {};
  if (!hiddenToStart) {
    style.display = "block";
  }

  const menu = (
    <Popover label={label !== undefined} baseClassName={`${baseClassName}__menu`}>
      {children}
    </Popover>
  );

  return (
    <div
      style={style}
      className={`${cx(baseClassName, label ? "" : "listed-more")}${
        hiddenToStart ? "" : " visible"
      }`}
    >
      <OverlayTrigger
        trigger="click"
        rootClose
        placement={placement}
        overlay={menu}
        closeOverlayOnClick={closeOnClick}
        triggerPassthrough={selectOnTrigger}
      >
        <span
          ref={buttonRef}
          data-e2e={uiPrefix(`${triggerPrefixClass}-context-menu-btn`)}
          style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
          className={`${uiPrefix(`${triggerPrefixClass}-context-menu-btn `)} ${
            label || iconComponent
              ? ""
              : `${iconClasses} listed-more-icon ${orientation && orientation}`
          }`}
        >
          {iconComponent ? <Icon type={iconComponent} size={16} /> : label}
        </span>
      </OverlayTrigger>
    </div>
  );
}

export default ContextMenu;
